var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Materiais"}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data}}),_c('List',{ref:"List",attrs:{"data":_vm.data},on:{"click-to-edit":function($event){return _vm.$refs.Form.loadToEdit($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }